import ScreenLock from '../__utils/screenLock';
import paginationBuilder from '../__utils/paginationBuilder';

const $ = jQuery.noConflict();

class PostsAjax {
    constructor(page, action) {
        // General
        this.page = $(page);
        this.action = action;
        this.loader = this.page.find('.loader');
        this.postsContent = this.page.find('.posts-content');
        this.postsWrapper = this.postsContent.find('.posts-cards__cards');
        this.postType = 'post';

        // Variables
        this.mobileViewport = window.matchMedia('(max-width: 991px)');
        this.transitionTime = 200;


        // Filters
        this.filtersWrapper = this.postsContent.find('.posts-filters');
        this.filterTrigger = this.filtersWrapper.find('.posts-filters__filter-trigger');
        this.filterList = this.filtersWrapper.find('.posts-filters__filter-list-outer');
        this.filtersInner = this.filtersWrapper.find('.posts-filters__inner');
        this.filtersInnerWrapper = this.filtersWrapper.find('.posts-filters__inner-wrapper');

        this.selectedItems = this.filtersWrapper.find('.selected-items');
        this.filtersSelected = this.filtersWrapper.find('.posts-filters__selected');
        this.filtersSelectedNumber = this.filtersSelected.find('.posts-filters__selected-number');
        this.clearTrigger = this.postsContent.find('.posts-filters__selected-reset');

        this.mobileTrigger = this.postsContent.find('.posts-filters__mobile-trigger');
        this.mobileCloseTrigger = this.postsContent.find('.posts-filters__mobile-close');
        this.mobileSelected = this.postsContent.find('.posts-filters__mobile-selected');
        this.filterInputs = this.filtersInner.find('.posts-filters__filter-list-item input[type=checkbox]');

        // Search form
        this.form = this.postsContent.find('.posts-content__search');

        //pagination
        this.pagination = this.postsContent.find('.pagination-ajax');

        // Data Passed
        this.types = [];
        this.categories = [];
        this.divisions = [];
    }

    init() {
        if (this.page.length) {
            this.triggerEvents();
            this.addUrlListener();
            this.applyTerms(true);
            this.showSelectedInputs();
        }
    }

    addUrlListener() {
        window.addEventListener('popstate', function() {
            location.reload(false);
        });
    }

    triggerEvents() {
        // Show mobile filters
        this.mobileTrigger.on('click', (e) => {
            e.preventDefault();
            this.filtersInnerWrapper.addClass('active');
            ScreenLock.lock();
        });

        // Close mobile filters
        this.mobileCloseTrigger.on('click', (e) => {
            e.preventDefault();
            this.filtersInnerWrapper.removeClass('active');
            ScreenLock.unlock();
        });



        // // Clear filters
        this.clearTrigger.on('click', (e) => {
            e.preventDefault();
            this.clearFilters();
        });

        // Toggle single filter terms dropdown
        this.filterTrigger.on('click', (e) => {
            e.preventDefault();
            this.toggleFilter(e.delegateTarget);
        });

        // Apply filter term
        this.filterInputs.on('change', () => {
            this.applyTerms();
        });


        //Pagination
        this.pagination.on('click', 'a.page-numbers, a.pagination__arrow', (e) => {
            e.preventDefault();
            this.applyFilters($(e.target).attr('data-page'));
        });

        // Submit search form
        this.form.on('submit', (e) => {
            e.preventDefault();
            this.applyTerms();
        });


        // Hide filters on viewport change
        this.mobileViewport.addListener(() => {
            this.filtersInnerWrapper.removeClass('active');
            this.filterTrigger.removeClass('active');
            this.filterList.removeClass('active').css('display', '');
            ScreenLock.unlock();
        });
    }

    lockLayout() {
        this.loader.addClass('active');
    }

    unlockLayout() {
        this.loader.removeClass('active');
    }

    toggleFilter(item) {
        const trigger = $(item);
        const list = trigger.next();

        if (trigger.hasClass('active')) {
            if (!this.mobileViewport.matches) list.stop().slideUp(this.transitionTime);
            this.filtersInner.removeClass('active');
            trigger.removeClass('active');
            list.removeClass('active');
        } else {
            if (!this.mobileViewport.matches) list.stop().slideDown(this.transitionTime);
            this.filtersInner.addClass('active');
            trigger.addClass('active');
            list.addClass('active');
        }
    }

    clearFilters() {
        this.filterInputs.prop('checked', false);
        this.applyTerms();
    }

    applyTerms(initial) {
        this.types = [];
        this.categories = [];
        this.divisions = [];

        //type
        this.filterInputs.filter((i, e) => $(e).data('tax') === 'news_type' && $(e).is(':checked')).each((i, e) => {
            this.types.push($(e).data('id'));
        });

        this.filterInputs.filter((i, e) => $(e).data('tax') === 'category' && $(e).is(':checked')).each((i, e) => {
            this.categories.push($(e).data('id'));
        });

        this.filterInputs.filter((i, e) => $(e).data('tax') === 'news_division' && $(e).is(':checked')).each((i, e) => {
            this.divisions.push($(e).data('id'));
        });


        if ( !initial ) {
            this.applyFilters();
        }
    }

    showSelectedInputs() {
        const checkedInputsNumber = this.filtersInner.find('input[type="checkbox"]:checked').length;
        if (checkedInputsNumber > 0) {
            this.filtersSelected.addClass('active');
            this.mobileSelected.addClass('active');
            this.filtersSelectedNumber.text( `(${checkedInputsNumber})`);
            this.mobileSelected.text(`${checkedInputsNumber}`);
        } else {
            this.filtersSelected.removeClass('active');
            this.mobileSelected.removeClass('active');
            this.filtersSelectedNumber.text( `(${0})`);
            this.mobileSelected.text('0');
        }

        this.filterTrigger.each((index, el) => {
            const checkedInputsFilter = $(el).parent().find('input[type="checkbox"]:checked').length;
            if(checkedInputsFilter > 0) {
                $(el).find('.selected-items').addClass('active');
                $(el).find('.selected-items').text( `${checkedInputsFilter}`);
            }else{
                $(el).find('.selected-items').removeClass('active');
                $(el).find('.selected-items').text( `${0}`);
            }
        });
    }


    updatePagination(current, max) {
        const page = parseInt(current);
        const max_num_pages = parseInt(max);

        this.pagination.find('.pagination__numbers-wrapper').html(paginationBuilder(this.postType, page, max_num_pages));
        this.pagination.find('.prev').attr('data-page', page - 1);
        this.pagination.find('.next').attr('data-page', page + 1);

        if (page === 1) {
            this.pagination.find('.prev').addClass('disabled');
        } else {
            this.pagination.find('.prev').removeClass('disabled');
        }

        if (page === max_num_pages) {
            this.pagination.find('.next').addClass('disabled');
        } else {
            this.pagination.find('.next').removeClass('disabled');
        }

        if (max_num_pages < 2) {
            this.pagination.addClass('hidden');
        } else {
            this.pagination.removeClass('hidden');
        }
    }


    applyFilters(page = 1) {
        this.lockLayout();

        const dataArr = this.form.serializeArray();
        const term = dataArr[0].value;
        $.ajax({
            type: 'POST',
            url: WP.ajaxUrl,
            dataType: 'JSON',
            data: {
                action: this.action,
                types: this.types,
                categories: this.categories,
                divisions: this.divisions,
                term,
                baseUrl: this.postsContent.attr('data-url'),
                page
            },
        })
        .done((response) => {
            history.pushState(null, null, response.url);
            this.updatePagination(response.page, response.max_num_pages);
            this.showSelectedInputs();
            this.postsWrapper.html(response.posts_content);
        })
        .fail((errorResponse) => {
            console.log('Error: ', errorResponse);
            alert('An error has occurred, please check console for more informations');
        })
        .always(() => {
            this.unlockLayout();
        });
    }
}

const postsFilters = new PostsAjax('body.blog', 'applyPostsFilters');

export default postsFilters;
